import React, { type FC } from 'react';
import { useParams } from 'react-router';

import { Alert } from '@shared/components/bootstrap';

import { Spinner } from '@admin/components/spinner';
import { useTitle } from '@admin/hooks/use_title';
import { client } from '@admin/libraries/apollo';
import { useAffiliateUpdateFormQuery, useAffiliateUpdateMutation } from '@admin/schema';

import { AffiliateForm } from './form';

export const AffiliateUpdateForm: FC = () => {
  useTitle('Edit Affiliate');
  const { id } = useParams<{ id: string }>();
  const { data, error } = useAffiliateUpdateFormQuery({ client, variables: { id } });
  const [execute, { loading: saving }] = useAffiliateUpdateMutation({ client });

  if (error) return <Alert style="danger">{error.message}</Alert>;
  if (!data) return <Spinner />;

  return (
    <AffiliateForm
      saving={saving}
      discountOptions={data.affiliateDiscountOptions}
      affiliate={data.affiliate}
      save={(input, address) => execute({ variables: { id, input, address } })}
    />
  );
};
